import React from 'react';
import { X } from 'lucide-react';
export function Problem() {
  const problems = ['Comprás globos y telas sin saber cómo va a quedar', 'Pinterest te da ideas pero no un plan real', 'No sabés cuánto cobrar sin quedar cara ni regalar tu trabajo', 'El cliente te pide algo y no tenés un contrato ni una seña', 'Armás todo de onda, pero cuando hay que cobrar, te achicás', 'Empezás, te frustrás, volvés a decorar gratis "para no perder el cliente"'];
  return <section className="py-16 px-5 bg-[#FFF9F1]" data-id="element-191">
      <div className="max-w-md mx-auto" data-id="element-192">
        <h2 className="text-2xl font-bold text-wine mb-4 text-center" data-id="element-193">
          ¿Cuántas veces más vas a improvisar y perder plata?
        </h2>
        <p className="text-center text-dark/70 mb-8 font-medium" data-id="element-194">
          Sin un sistema claro, siempre termina igual.
        </p>

        <ul className="space-y-4 mb-10" data-id="element-195">
          {problems.map((prob, idx) => <li key={idx} className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-sm border border-cream" data-id="element-196">
              <div className="bg-red-50 p-1 rounded-full shrink-0" data-id="element-197">
                <X className="w-4 h-4 text-red-500" data-id="element-198" />
              </div>
              <span className="text-[15px] text-dark/80 leading-snug" data-id="element-199">
                {prob}
              </span>
            </li>)}
        </ul>

        <div className="bg-pink-pastel rounded-2xl p-6 text-center shadow-md" data-id="element-200">
          <p className="text-wine font-bold text-lg leading-snug" data-id="element-201">
            No te falta talento. Te falta un sistema.
          </p>
          <p className="text-wine/80 mt-2 text-[15px]" data-id="element-202">
            Con Decora Fácil PRO, tu próximo evento puede ser el primero que
            cobrás como corresponde. 🎀
          </p>
        </div>
      </div>
    </section>;
}